var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoToChatLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16671 16.6667L0.833374 10L9.16671 3.33337V7.50004C13.7692 7.50004 17.5 11.2309 17.5 15.8334C17.5 16.0609 17.4917 16.2859 17.4734 16.5084C16.2542 14.1967 13.865 12.5992 11.0942 12.5042L10.8334 12.5H9.16671V16.6667ZM7.50004 10.8334H10.8617L11.1509 10.8392C12.2217 10.875 13.2542 11.0975 14.2142 11.4775C12.9917 10.0625 11.1834 9.16671 9.16671 9.16671H7.50004V6.80087L3.50171 10L7.50004 13.1992V10.8334Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToChatLink);
export default __webpack_public_path__ + "static/media/go_to_chat_link.3f1d8d87.svg";
export { ForwardRef as ReactComponent };